import { ListViewBody, ListViewLabel } from '@/components/ListView';
import { ApprovalStep } from '@/components/InvoiceReportDetailDrawer/ApprovalRouteDrawer';
import { useTranslation } from '@/i18n';
import { useGlobalContainerRef } from '@/wc/helper/ref';
import {
  ListViewBody as ApListViewBody,
  IconHelp,
  Loading,
  Tooltip,
  Top,
} from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo, Suspense } from 'react';
import { useApprovalRoute } from '../hooks/useApprovalRoute';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

type InnerContentsProps = {
  reportId: string;
  onCloseDetailDrawer: () => void;
};

const InnerContents: FC<InnerContentsProps> = ({
  reportId,
  onCloseDetailDrawer,
}) => {
  const container = useGlobalContainerRef();
  const { data } = useApprovalRoute({ reportId, onCloseDetailDrawer });
  const { t } = useTranslation();
  return (
    <div className={cx('container')}>
      <ApListViewBody className={cx('list-view-body')}>
        <Top>
          <ListViewLabel>
            <div className={cx('label-container')}>
              <span>{t('approving_invoice_reports.approval_route')}</span>
              <Tooltip
                title={t('approving_invoice_reports.approval_route.tooltip')}
                getPopupContainer={container}
                overlayClassName={cx('tooltip-container')}
              >
                <span>
                  <IconHelp size={14} />
                </span>
              </Tooltip>
            </div>
          </ListViewLabel>
          <ListViewBody>{data?.workflow_route?.name}</ListViewBody>
        </Top>
        {data?.steps?.map((step) => (
          <ApprovalStep key={step.name} step={step} />
        ))}
      </ApListViewBody>
    </div>
  );
};

const FallBackLoading = () => (
  <div className={cx('loading-container')}>
    <Loading size='large' color='default' />
  </div>
);

export const Contents: FC<InnerContentsProps> = memo((props) => (
  <Suspense fallback={<FallBackLoading />}>
    <InnerContents {...props} />
  </Suspense>
));
Contents.displayName = 'Contents';
